import Welcome from '@/views/guests/Welcome'
import Imprint from '@/views/guests/Imprint'
import Login from '@/views/guests/auth/Login'
import Password from '@/views/guests/auth/Password'
import Registration from '@/views/guests/registration/Registration'
import Resend from '@/views/guests/registration/Resend'
import Join from '@/views/guests/registration/Join'
import EmailConfirmation from '@/views/guests/Confirmation'

export default [
  {
    path: '/',
    name: 'root',
    component: Welcome
  },
  {
    path: '/impressum',
    name: 'imprint',
    component: Imprint
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Registration
  },
  {
    path: '/resend',
    name: 'resend',
    component: Resend
  },
  {
    path: '/join',
    name: 'join',
    component: Join
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: EmailConfirmation
  },
  {
    path: '/password',
    name: 'password',
    component: Password
  }
]



//////////////////
// WEBPACK FOOTER
// ./src/router/routes.guests.js
// module id = 843
// module chunks = 1